import { render } from "./PublicationEntry.vue?vue&type=template&id=1e47f7bf&scoped=true"
import script from "./PublicationEntry.vue?vue&type=script&lang=js"
export * from "./PublicationEntry.vue?vue&type=script&lang=js"

import "./PublicationEntry.vue?vue&type=style&index=0&id=1e47f7bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e47f7bf"]])

export default __exports__